const TOMA_USADOS_PATHS = new Set(['/toma-usados', '/usados/toma'])

export function parseTomaFichaId (value) {
  if (typeof value !== 'string' || !/^\d+$/.test(value)) return null
  const id = Number(value)
  return Number.isSafeInteger(id) && id > 0 ? id : null
}

export function createTomaUsadosReturnTo (path, ficha) {
  const id = parseTomaFichaId(ficha)
  if (!id || !TOMA_USADOS_PATHS.has(path)) return null
  return `${path}?ficha=${id}`
}

export function resolveTomaUsadosReturnTo (value) {
  if (typeof value !== 'string' || value.includes('\\')) return null
  const match = /^(\/toma-usados|\/usados\/toma)\?ficha=(\d+)$/.exec(value)
  const id = match && parseTomaFichaId(match[2])
  if (!match || !id) return null
  return `${match[1]}?ficha=${id}`
}
